// extracted by mini-css-extract-plugin
export default {"component":"SimpleButtonStyles_component__mMad8","text":"SimpleButtonStyles_text__4Ab5G","componentProcessing":"SimpleButtonStyles_componentProcessing__PzdyV"};